export default {"src":"/_next/static/media/cny.68e65924.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};